import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createPartnerMemberContract,
  type CreatePartnerMemberRequest,
  type CreatePartnerMemberResponse
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { orgMemberKeys } from '@/api/query-keys';

/**
 * Manually invite a person into the partner tenant by email (the non-HubSpot
 * path). On success the team (org-member) list is invalidated so the new
 * pending member appears.
 */
export function useCreatePartnerMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreatePartnerMemberRequest): Promise<CreatePartnerMemberResponse> => {
      const { data } = await apiClient.post<CreatePartnerMemberResponse>(
        createPartnerMemberContract.path,
        body
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: orgMemberKeys.all });
    }
  });
}
